import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { queryKeys, staleTimes } from '../config/queryClient';

/**
 * Hook para obtener las sucursales de una tienda por subdominio
 * 
 * @param {string} subdomain - Subdominio de la tienda
 * @param {object} options - Opciones adicionales
 * @returns {object} - { data: branches[], isLoading, error }
 */
export const useShopBranches = (subdomain, options = {}) => {
  return useQuery({
    queryKey: queryKeys.shopBranches(subdomain),
    
    queryFn: async () => {
      const response = await axios.get(
        process.env.REACT_APP_API_SHOP_SUBDOMAIN_ROUTE,
        {
          params: {
            subdomain,
          },
        }
      );
      return response.data;
    },
    
    enabled: !!subdomain,
    
    // Sucursales casi nunca cambian
    staleTime: staleTimes.static, // 1 hora
    
    cacheTime: 2 * 60 * 60 * 1000, // 2 horas
    
    ...options,
  });
};
